<template>
    <div class="home">
        <filters-container></filters-container>
        <tab-container></tab-container>
        <transition name="fade">
            <comments-container v-if="notificationsOpen"></comments-container>
        </transition>
    </div>
</template>

<script>
import store from '@/store';

import FiltersContainer from '@/components/FiltersContainer';
import TabContainer from '@/components/TabContainer';
import CommentsContainer from '@/components/CommentsContainer';

export default {
    components: {
        FiltersContainer,
        TabContainer,
        CommentsContainer,
    },
    computed: {
        commentsData() {
            return store.state.appData.comments;
        },
        notificationsOpen() {
            return store.state.notificationsOpen;
        },
    },
    mounted() {
        store.dispatch('refreshAllData');
        store.dispatch('refreshNotificationsData');
    },
    destroyed() {
        store.commit('refreshDcmData', {});
    },
};
</script>
<style>
    @keyframes pulse {
        0% {
            opacity: 0;
        }

        100% {
            opacity: 1;
        }
    }
</style>
<style lang="scss" scoped>
    @import '../../assets/scss/partials/variables';

    .home {
        padding-bottom: 47px;

        @media screen and (min-width: $tablet) {
            padding-bottom: 142px;
        }

        @media screen and (min-width: $desktop) {
            padding-bottom: 92px;
        }
    }

    .loading {
        margin-bottom: 43px;
        color: $kpmg-blue;
        text-align: center;

        .indicator {
            opacity: 0;
            animation-duration: 0.9s;
            animation-name: pulse;
            animation-direction: alternate;
            animation-iteration-count: infinite;

            &:nth-child(2) {
                animation-delay: 0.3s;
            }
            &:nth-child(3) {
                animation-delay: 0.6s;
            }
        }
    }

    .fade-leave-active,
    .fade-enter-active {
        transition: opacity 0.4s ease;
    }

    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }

    .fade-enter-to,
    .fade-leave {
        opacity: 1;
    }

    .fade-chart-leave-active,
    .fade-chart-enter-active {
        transition: opacity 0.2s ease;
    }

    .fade-chart-enter,
    .fade-chart-leave-to {
        opacity: 0;
    }

    .fade-chart-enter-to,
    .fade-chart-leave {
        opacity: 1;
    }
</style>




// WEBPACK FOOTER //
// src/components/pages/Home.vue